import ewbApi from "network/ewbApi";
import { BANNER } from "network/endpoints";

export const getHolidayBanner = async () => ewbApi.get(BANNER.holiday_banner);
